import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
const AccountPlanTrialFormEmailFieldArray = (props) => {
    const { fields, render } = props;
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
    }, [fields]);
    return (_jsx("div", Object.assign({ className: 'proffit_search_account_plan_trial_form_emails' }, { children: fields.length > 0 && (_jsx("div", Object.assign({ className: 'emails_list' }, { children: fields.map((field, index) => render({
                field,
                index,
                length: fields.length,
                onClickDelete,
            })) }))) })));
};
AccountPlanTrialFormEmailFieldArray.propTypes = {
    fields: propShape().isRequired,
    render: propFunc().isRequired,
};
export default AccountPlanTrialFormEmailFieldArray;
